export const en: { [key: string]: string } = {
  /** Sections **/
  'section.about': 'About',
  'section.demo': 'Demo',
  'section.contact': 'Contact',
  'section.features': 'Features',
  'section.download': 'Download',
  'section.youtube': 'Video',

  /** Sections content */
  'section.demo.desc': 'Stop waiting.\nTry the web demo.',

  /** Common */
  error: 'Oops, something went wrong...',
  'error.button': 'Reload page',

  'mild-blue.coop': 'Created in collaboration with',
};

export type LanguageStrings = typeof en;
